<script setup lang="ts">
    const props = defineProps<{
        withCheckMarks?: boolean;
    }>();
</script>
<template>
    <div class="mui-text-wrapper" :class="{'mui-text-wrapper--with-check-marks': props.withCheckMarks}">
        <slot />
    </div>
</template>
<style lang="scss">
    .mui-text-wrapper {
        width: 100%;
        height: 100%;

        &--with-check-marks {
            ul {
                padding: 0;
                margin: 0;
                list-style: none;

                li {
                    list-style-type: none;
                    padding-left: var(--joy-core-spacing-7);
                    margin-bottom: var(--joy-core-spacing-3);
                    background-image: url('../assets/svg/check.svg');
                    background-repeat: no-repeat;
                    background-position: left center;
                    background-size: 15px 15px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
</style>
